import { render, staticRenderFns } from "./walletDetail.vue?vue&type=template&id=07290a60&scoped=true&"
import script from "./walletDetail.vue?vue&type=script&lang=js&"
export * from "./walletDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07290a60",
  null
  
)

export default component.exports